var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgSmallsearch = function SvgSmallsearch(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    style: {
      verticalAlign: "middle"
    },
    viewBox: "0 0 24 24",
    preserveAspectRatio: "xMidYMid meet",
    "aria-labelledby": "title"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.5 22.8l-4.2-7.2c1.9-1.6 3.2-4 3.2-6.7 0-5-4-8.9-8.8-8.9S2.5 4 2.5 8.9s4 8.8 8.8 8.8c1.3 0 2.6-.3 3.7-.8l4.2 7 2.3-1.1zM5 8.9c0-3.5 2.9-6.4 6.4-6.4 3.5 0 6.4 2.9 6.4 6.4s-2.9 6.4-6.4 6.4C8 15.4 5 12.6 5 8.9z"
  })));
};
export { SvgSmallsearch as ReactComponent };